import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { AlertType, Caixa, classBorderLabelDark, classBt, classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, classWeigthBt, classbtAzul, classbtCeuAzul, classbtColunasAzul } from '../../Utils/Types'
import { FaMoneyBill1Wave } from 'react-icons/fa6'
import { Height } from '@mui/icons-material'
import { DataSearch, SearchBox } from '../../Components/SearchBox/SearchBox'
import { ExtratoConta, LanctoCaixaService } from './LanctoCaixaService'
import { GridExtratoContas } from '../../Components/GridProducts/GridExtratoContas'
import moment from 'moment'
import { FaPrint, FaSearch, FaVideo } from 'react-icons/fa'
import { Funcoes } from '../../Utils/Funcoes'
import { ReportExtratoCaixaPDF } from './pdf/report-extrato-caixa'
import { IoPrint } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { selectUser } from '../../Components/Redux/userSlice'
import extratoEscuro from '../../assets/imagens/ExtratoEscuro.svg'
import extratoClaro from '../../assets/imagens/ExtratoClaro.svg'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'

export const ExtratoContasPage = () => {

    const [divHeight, setDivHeight] = useState(0)


    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [loading, setLoading] = useState(false)
    const [feedbackVisible, setFeedbackVisible] = useState(false)
    const [feedbackMessage, setFeedbackMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")


    // -----------------------------------------------
    // ---------- ATRIBUTOS  -------------------------
    // -----------------------------------------------
    const [datai, setDatai] = useState(moment().format("yyyy-MM-DD"))
    const [dataf, setDataf] = useState(moment().format("yyyy-MM-DD"))
    const [tipo, setTipo] = useState("")

    // CONTAS
    const [contasFilter, setContasFilter] = useState<DataSearch[]>([])
    const [idConta, setIdConta] = useState(0)
    const [contas, setContas] = useState<DataSearch[]>([])


    // -----------------------------------------------
    // ---------- ATRIBUTOS INFORMAÇÕES --------------
    // -----------------------------------------------
    const [saidas, setSaidas] = useState(0)
    const [entradas, setEntradas] = useState(0)
    const [saldoAnterior, setSaldoAnterior] = useState(0)
    const [saldoAtual, setSaldoAtual] = useState(0)

    const [extratoList, setExtratoList] = useState<Caixa[]>([])
    const [extratoCaixa, setExtratoCaixa] = useState<ExtratoConta>({ totEnt: 0, totSai: 0, saldoAnterior: 0, saldoAtual: 0, extrato: [] })


    // -----------------------------------------------
    // ---------- TEMAS ------------------------------
    // -----------------------------------------------
    const [tema, setTema] = useState("")
    let user = useSelector(state => selectUser(state))


    // -----------------------------------------------
    // ------------------ SEARCHBOX ------------------
    // -----------------------------------------------
    const [visibleSearchBoxConta, setVisibleSearchBoxConta] = useState<boolean>(false)


    // -----------------------------------------------
    // ---------- ATRIBUTOS TUTORIAL -----------------
    // -----------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    //----------------------------------------------------------------------------------------- ATTRIBUTES E EFFECT -------------------------------------------------------------- ||
    const GetAttributes = async () => {

        setLoading(true)

        try {

            const attributes = await LanctoCaixaService.GetAttributes()
            setContas(attributes.data)
            setContasFilter(attributes.data)

        } catch (error) {

            setFeedbackVisible(true)
            setMessageType("DANGER")
            setFeedbackMessage("Não foi possível buscar as contas")

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setTema(user.modeDark)
    }, [user.modeDark])

    useEffect(() => {
        setDivHeight(Math.round(window.innerHeight * 0.80))
        GetAttributes()
    }, [])

    const handleKeyPressEnter = async (e: any) => {

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxConta && !loading) {
            await handleFiltrarDados()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [datai, dataf, idConta, tipo, visibleSearchBoxConta, loading])

    //------------------------------------------------------------------------------------------------------ INPUTS --------------------------------------------------------------------------- ||
    const handleChangeDatai = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDataf = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeTipo = (e: ChangeEvent<HTMLSelectElement>) => {
        setTipo(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------ CONTAS --------------------------------------------------------------------------- ||
    const handleClearContaCreditoSelecionada = useCallback(() => {
        let newContas = [...contas]
        setContasFilter(newContas)
        setIdConta(0)

        setVisibleSearchBoxConta(false)
    }, [contas])

    const handleSetContaClick = useCallback((conta: DataSearch) => {
        if (conta) {
            let newContas = [...contas]
            setContasFilter(newContas)
            setIdConta(conta.id)
        }

        setVisibleSearchBoxConta(false)
    }, [contas])

    const handleFilterContaClick = useCallback((description: string) => {

        if (description === "") {

            const newContas = [...contas]
            setContasFilter(newContas)

        } else {

            const newContas = [...contas || []].filter((conta) => {
                return conta.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setContasFilter(newContas || [])
        }
    }, [contas])


    //------------------------------------------------------------------------------------------------------ EXTRATOS --------------------------------------------------------------------------- || 
    const handleFiltrarDados = async () => {

        setFeedbackVisible(false)
        setLoading(true)

        try {

            handleInputFocus()
            setExtratoList([])

            const retApi = await LanctoCaixaService.Extrato(datai, dataf, tipo, idConta)
            setExtratoCaixa(retApi.data)

            if (retApi.error) {

                setFeedbackVisible(true)
                setMessageType("DANGER")
                setFeedbackMessage(retApi.msg || '')

                setSaldoAnterior(0)
                setSaldoAtual(0)
                setEntradas(0)
                setSaidas(0)
                setExtratoCaixa({ totEnt: 0, totSai: 0, saldoAnterior: 0, saldoAtual: 0, extrato: [] })

            } else {
                setSaldoAnterior(retApi.data.saldoAnterior)
                setSaldoAtual(retApi.data.saldoAtual)
                setEntradas(retApi.data.totEnt)
                setSaidas(retApi.data.totSai)
                setExtratoList(retApi.data.extrato || [])
            }

        } catch (error) {

            setFeedbackVisible(true)
            setMessageType("DANGER")
            setFeedbackMessage("Não foi possível buscar os dados.")

        } finally {
            setLoading(false)
        }
    }

    const handlePrintData = async (event: any) => {

        setFeedbackVisible(false)

        if (extratoCaixa.extrato.length > 0) {

            const report = new ReportExtratoCaixaPDF(extratoCaixa, datai, dataf)
            report.GerarPDF()

        } else {

            const timer = setTimeout(() => {
                setFeedbackVisible(true)
                setMessageType("DANGER")
                setFeedbackMessage("Não há nenhuma informação disponível para a impressão.")
                clearTimeout(timer)
            }, 250)
        }

        event.currentTarget.blur()

    }

    const handleCloseFeedbackMessage = () => {
        setFeedbackVisible(false)
    }

    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    const handleInputFocus = () => {
        setVisibleSearchBoxConta(false)
    }

    const clickSearchBoxConta = useCallback(() => {
        setVisibleSearchBoxConta((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                inputFocusContaCredito()
            }
            return newState
        })
    }, [])

    const inputFocusContaCredito = () => {
        let inputSearch = document.getElementById(`inputSearchBox-conta`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={feedbackVisible} message={feedbackMessage} type={messageType} onCloseMessage={handleCloseFeedbackMessage} />

                    <div className={`${classDivTitulo}`}>

                        <div className={`m-2`}>
                            <div className={`flex items-center h-[50px] bg-slate-200 dark:bg-slate-700 border border-slate-300 dark:border-slate-800 rounded-sm `}>

                                <div className='mx-2'>
                                    {tema === 'dark' &&

                                        <img src={extratoClaro} alt="Estorno" className={`h-6 w-6 flex items-center justify-center`} />
                                    }

                                    {tema === 'light' &&

                                        <img src={extratoEscuro} alt="Estorno" className={`h-6 w-6 flex items-center justify-center`} />

                                    }
                                </div>

                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Extrato das contas</span>

                                <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} max-w-[150px] h-9 shadow-md shadow-blue-600 mx-2`}  >
                                    <FaVideo />
                                    <span className='mx-1'>Tutorial</span>
                                </button>
                            </div>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`w-full h-auto grid grid-cols-12 gap-3 py-2 px-2 cursor-default`}>

                                <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 mt-2`}>
                                    <input id="datai" className={`${classInput} ${classInputDark} ${datai === '' ? 'text-blue-500 dark:text-cyan-300' : ''} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=" " value={datai} onFocus={handleInputFocus} onChange={handleChangeDatai} />
                                    <label htmlFor="datai" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data inicial</label>
                                </div>

                                <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 mt-2`}>
                                    <input id="dataf" className={`${classInput} ${classInputDark} ${dataf === '' ? 'text-blue-500 dark:text-cyan-300' : ''} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=" " value={dataf} onFocus={handleInputFocus} onChange={handleChangeDataf} />
                                    <label htmlFor="dataf" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data final</label>
                                </div>

                                <div className={`relative col-span-12 md:col-span-4 xl:col-span-2 mt-2`}>

                                    <select className={`${classInput} ${classInputDark}`} value={tipo} onFocus={handleInputFocus} onChange={handleChangeTipo}>
                                        <option value="">Todos</option>
                                        <option value="C">Crédito</option>
                                        <option value="D">Débito</option>
                                    </select>
                                    <label htmlFor="dataf" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Tipo do lançamento</label>
                                </div>

                                <div className={`relative col-span-12 xl:col-span-6 mt-2`}>
                                    <SearchBox
                                        dataList={contasFilter}
                                        idRegistro={idConta}
                                        label='Conta'
                                        componentId='conta'
                                        visibleTAB={visibleSearchBoxConta}
                                        setDataClick={handleSetContaClick}
                                        clearDataClick={handleClearContaCreditoSelecionada}
                                        filterDataClick={handleFilterContaClick}
                                        clicado={clickSearchBoxConta}
                                    />
                                </div>

                                <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                    <div className={`relative mt-2 sm:mt-0`}>

                                        <button tabIndex={-1} disabled={loading || !(extratoList.length > 0)} className={`${classBt} ${classbtCeuAzul} disabled:bg-opacity-50 disabled:cursor-not-allowed w-full sm:min-w-[150px]`} onClick={handlePrintData} >
                                            <IoPrint size="20px" className={`mr-2`} />
                                            Imprimir
                                        </button>

                                    </div>

                                    <div className={`relative mt-6 sm:mt-0`}>

                                        <button tabIndex={-1} disabled={loading} className={`${classBt} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFiltrarDados} >
                                            {!loading &&
                                                <FaSearch className='mx-1' />
                                            }
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading ? `Pesquisar` : `Aguarde`}
                                        </button>

                                    </div>

                                </div>

                                <div className={`relative col-span-12`}>
                                    <div className={`w-full h-[1px] bg-slate-200 dark:bg-slate-700`} />
                                </div>

                                <div className={`col-span-12`}>

                                    <div className={`flex flex-col justify-start w-full h-auto border border-slate-500 rounded-md bg-gray-200 dark:bg-slate-700`}>

                                        <div className={`md:flex md:flex-row md:border md:border-x-0 md:border-t-0 md:border-slate-400 md:dark:border-slate-500 md:py-2`}>

                                            <div className={`w-full font-mono py-2 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                                <span className={`w-full md:w-auto`}>(-) Saídas: </span>
                                                <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(saidas, 'currency')}</span>
                                            </div>

                                            <div className={`w-full font-mono py-2 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                                <span className={`w-full md:w-auto`}>(+) Entradas: </span>
                                                <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(entradas, 'currency')}</span>
                                            </div>

                                        </div>

                                        <div className={`md:flex md:flex-row md:py-2`}>

                                            <div className={`w-full font-mono py-2 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                                <span className={`w-full md:w-auto`}>Saldo Anterior: </span>
                                                <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(saldoAnterior, 'currency')}</span>
                                            </div>

                                            <div className={`w-full font-mono py-2 px-2 dark:text-slate-200 flex flex-row`}>
                                                <span className={`w-full md:w-auto`}>Saldo Atual: </span>
                                                <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(saldoAtual, 'currency')}</span>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 bg-white dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800 `}>
                        <GridExtratoContas extratoList={extratoList} />
                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_extratoConta.mp4'
                            title='Como gerar o extrato de contas'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>

    )
}